import React from 'react';
import { Button, Icon, Loader, ModalBox, useMediaQueryContext } from '@fourthwall/components';
import { SecureBadgeIcon } from '@fourthwall/icons';
import { SelectPaymentMethod } from '@modules/Dashboard/modules/PaymentMethods';
import * as S from './PaymentMethodRequiredModal.styled';
export const PaymentMethodRequiredModalView = ({ title, subtitle, submitLabel, withChargeLimit, onSuccess, onClose, onAddPaymentMethodClose, }) => {
    const media = useMediaQueryContext();
    const renderSubtitle = (isLoading) => {
        if (!subtitle || isLoading) {
            return null;
        }
        return React.createElement(S.Subtitle, null, subtitle);
    };
    return (React.createElement(SelectPaymentMethod, { submitLabel: submitLabel, withChargeLimit: withChargeLimit, onSuccess: onSuccess, onAddPaymentMethodClose: onAddPaymentMethodClose }, ({ renderContent, renderSubmitButton, isLoading }) => (React.createElement(ModalBox, { title: title, buttons: [
            React.createElement(Button, { label: "Cancel", appearance: "secondary", onClick: onClose }),
            renderSubmitButton({ fullWidth: !media.tablet }),
        ], footer: React.createElement(Icon, { component: SecureBadgeIcon, height: 20 }), onClose: onClose },
        isLoading && (React.createElement(S.LoaderWrapper, null,
            React.createElement(Loader, { size: "large" }))),
        renderSubtitle(isLoading),
        renderContent()))));
};
